import React from 'react'
import cx from 'classnames'

import styles from './TemplateCard.module.scss'

type TemplateCardProps = {
  children?: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  isActive?: boolean
  isDisabled?: boolean
}

export const TemplateCard = ({
  children,
  onClick,
  isActive,
  isDisabled,
}: TemplateCardProps) => (
  <button
    className={cx(styles.card, { [styles.active]: isActive })}
    disabled={isDisabled}
    {...{ onClick }}
  >
    <span className={styles.content}>{children}</span>
  </button>
)
